import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dataset.instruction.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-page-dataset-instruction-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dataset.instruction.detail/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDatasetInstructionDetailComponent implements OnInit, OnDestroy {
    public dataset: any = null;
    public collection: any = null;
    public qaList: any[] = [];
    public loading: boolean = true;
    public qaLoading: boolean = false;
    public page: number = 1;
    public totalPages: number = 1;
    public id: string = '';

    // Models
    public models: any[] = [
        { id: 'gpt-5', name: 'GPT-5', provider: 'OpenAI' },
        { id: 'gpt-5-mini', name: 'GPT-5 Mini', provider: 'OpenAI' },
        { id: 'gpt-5-turbo', name: 'GPT-5 Turbo', provider: 'OpenAI' },
        { id: 'gemini-3.0-flash', name: 'Gemini 3.0 Flash', provider: 'Google' },
        { id: 'gemini-3.0-pro', name: 'Gemini 3.0 Pro', provider: 'Google' },
    ];
    public selectedModel: any = this.models[0];
    public showModelDropdown: boolean = false;
    public generating: boolean = false;
    public uploading: boolean = false;

    // Generate modal
    public showGenerateModal: boolean = false;
    public generateCount: number = 10;
    public generateTone: string = '';
    public generateTaskTypes: string[] = [];
    public generateResponseLength: string = '';
    public generateCustomPrompt: string = '';

    // Progress
    public showProgressModal: boolean = false;
    public progressStep: string = '';
    public progressMessage: string = '';
    public progressPercent: number = 0;
    public progressSaved: number = 0;
    public progressTotal: number = 0;
    public progressError: string = '';
    public progressDone: boolean = false;

    // Download
    public showDownloadDropdown: boolean = false;

    // Assign
    public assignedUsers: any[] = [];
    public showAssignModal: boolean = false;
    public userList: any[] = [];
    public loadingUsers: boolean = false;
    public selectedUserIds: string[] = [];

    // Edit
    public editingQaId: string = '';
    public editSystem: string = '';
    public editInstruction: string = '';
    public editResponse: string = '';

    // Delete QA
    public showDeleteQaModal: boolean = false;
    public deleteQaTarget: any = null;

    // Expand system prompt
    public expandedSystem: any = {};

    // Tone/Task options
    public toneOptions = [
        { value: 'friendly', label: '친근한 상담형' },
        { value: 'professional', label: '전문적 학술형' },
        { value: 'educational', label: '교육적 설명형' },
    ];

    public taskTypeOptions = [
        { value: 'consultation', label: '진료 상담' },
        { value: 'prescription', label: '처방 설명' },
        { value: 'symptom', label: '증상 분석' },
        { value: 'concept', label: '개념 설명' },
        { value: 'comparison', label: '비교 분석' },
    ];

    public responseLengthOptions = [
        { value: 'short', label: '간결' },
        { value: 'medium', label: '보통' },
        { value: 'detailed', label: '상세' },
    ];

    private routerSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        if (!this.id) {
            this.service.href('/dataset/instruction');
            return;
        }
        await this.loadDataset();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                if (newId && newId !== this.id) {
                    this.id = newId;
                    await this.loadDataset();
                    await this.service.render();
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    // ── Data Loading ──

    public async loadDataset() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.id });
        if (code === 200) {
            this.dataset = data.dataset;
            this.collection = data.collection || null;
            this.qaList = data.qa_list || [];
            this.totalPages = data.total_pages || 1;
            this.assignedUsers = data.assigned_users || [];
        } else {
            this.service.href('/dataset/instruction');
            return;
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        this.qaLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('qa_list', { dataset_id: this.id, page: this.page });
        if (code === 200) {
            this.qaList = data.list || [];
            this.totalPages = data.total_pages || 1;
        }
        this.qaLoading = false;
        await this.service.render();
    }

    // ── Finalize / Reopen ──

    get isCompleted(): boolean {
        return this.dataset?.status === 'completed';
    }

    get isReviewComplete(): boolean {
        if (!this.dataset) return false;
        const total = this.dataset.total_count || 0;
        if (total === 0) return false;
        const reviewed = (this.dataset.approved_count || 0) + (this.dataset.rejected_count || 0) + (this.dataset.skipped_count || 0);
        return reviewed >= total;
    }

    get reviewPercent(): number {
        if (!this.dataset) return 0;
        const total = this.dataset.total_count || 0;
        if (total === 0) return 0;
        const reviewed = (this.dataset.approved_count || 0) + (this.dataset.rejected_count || 0) + (this.dataset.skipped_count || 0);
        return Math.round((reviewed / total) * 100);
    }

    public async finalize() {
        if (!this.isReviewComplete) return;
        const res = await this.service.alert.show({
            title: '데이터셋 마감',
            message: '마감하면 QA 생성, 할당, 업로드, 삭제가 비활성화됩니다. 마감하시겠습니까?',
            action: '마감',
            actionBtn: 'bg-emerald-500 hover:bg-emerald-600',
            cancel: '취소'
        });
        if (!res) return;
        const { code } = await wiz.call('finalize', { dataset_id: this.id });
        if (code === 200) await this.loadDataset();
    }

    public async reopen() {
        const res = await this.service.alert.show({
            title: '마감 해제',
            message: '데이터셋 마감을 해제하고 검수 상태로 되돌리시겠습니까?',
            action: '해제',
            cancel: '취소'
        });
        if (!res) return;
        const { code } = await wiz.call('reopen', { dataset_id: this.id });
        if (code === 200) await this.loadDataset();
    }

    // ── QA Delete ──

    public async openDeleteQa(qa: any) {
        this.deleteQaTarget = qa;
        this.showDeleteQaModal = true;
        await this.service.render();
    }

    public async confirmDeleteQa() {
        if (!this.deleteQaTarget) return;
        const { code } = await wiz.call('delete_qa', { qa_id: this.deleteQaTarget.id, dataset_id: this.id });
        this.showDeleteQaModal = false;
        this.deleteQaTarget = null;
        if (code === 200) await this.loadDataset();
        else await this.service.render();
    }

    // ── QA Edit ──

    public async startEdit(qa: any) {
        this.editingQaId = qa.id;
        this.editSystem = qa.system_prompt || '';
        this.editInstruction = qa.question || '';
        this.editResponse = qa.answer || '';
        await this.service.render();
    }

    public async cancelEdit() {
        this.editingQaId = '';
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.editingQaId) return;
        const { code } = await wiz.call('update_qa', {
            qa_id: this.editingQaId,
            dataset_id: this.id,
            system_prompt: this.editSystem,
            question: this.editInstruction,
            answer: this.editResponse,
        });
        this.editingQaId = '';
        if (code === 200) await this.loadPage(this.page);
        else await this.service.render();
    }

    // ── Model Selection ──

    get openaiModels() { return this.models.filter(m => m.provider === 'OpenAI'); }
    get googleModels() { return this.models.filter(m => m.provider === 'Google'); }

    public async toggleModelDropdown() {
        this.showModelDropdown = !this.showModelDropdown;
        this.showDownloadDropdown = false;
        await this.service.render();
    }

    public async selectModel(model: any) {
        this.selectedModel = model;
        this.showModelDropdown = false;
        await this.service.render();
    }

    // ── Generate Modal ──

    public async openGenerateModal() {
        this.showGenerateModal = true;
        this.showModelDropdown = false;
        this.generateTone = this.dataset?.tone || '';
        this.generateTaskTypes = [...(this.dataset?.task_types || [])];
        this.generateResponseLength = this.dataset?.response_length || '';
        this.generateCustomPrompt = this.dataset?.prompt || '';
        await this.service.render();
    }

    public async closeGenerateModal() {
        this.showGenerateModal = false;
        await this.service.render();
    }

    public toggleGenTaskType(value: string) {
        const idx = this.generateTaskTypes.indexOf(value);
        if (idx >= 0) this.generateTaskTypes.splice(idx, 1);
        else this.generateTaskTypes.push(value);
    }

    // ── Generate Confirm ──

    public async confirmGenerate() {
        if (this.generating) return;
        this.showGenerateModal = false;
        this.generating = true;
        this.showProgressModal = true;
        this.progressStep = 'init';
        this.progressMessage = '생성 준비 중...';
        this.progressPercent = 0;
        this.progressSaved = 0;
        this.progressTotal = 0;
        this.progressError = '';
        this.progressDone = false;
        await this.service.render();

        const formData = new FormData();
        formData.append('dataset_id', this.id);
        formData.append('model_id', this.selectedModel.id);
        formData.append('count', String(this.generateCount));
        formData.append('custom_prompt', this.generateCustomPrompt);
        formData.append('tone', this.generateTone);
        formData.append('task_types', JSON.stringify(this.generateTaskTypes));
        formData.append('response_length', this.generateResponseLength);

        try {
            const response = await fetch(
                '/wiz/api/page.dataset.instruction.detail/generate',
                { method: 'POST', body: formData }
            );
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            await this.handleGenerateEvent(event);
                        } catch {}
                    }
                }
            }
        } catch (e: any) {
            this.progressError = `네트워크 오류: ${e.message || '연결 실패'}`;
            this.progressDone = true;
            await this.service.render();
        }
        this.generating = false;
        await this.service.render();
    }

    private async handleGenerateEvent(event: any) {
        if (event.type === 'progress') {
            this.progressStep = event.step || '';
            this.progressMessage = event.message || '';
            this.progressPercent = event.percent || 0;
            if (event.saved !== undefined) this.progressSaved = event.saved;
            if (event.total !== undefined) this.progressTotal = event.total;
        } else if (event.type === 'complete') {
            this.progressStep = 'complete';
            this.progressMessage = event.message || '생성 완료';
            this.progressPercent = 100;
            if (event.saved !== undefined) this.progressSaved = event.saved;
            if (event.total !== undefined) this.progressTotal = event.total;
            this.progressDone = true;
        } else if (event.type === 'error') {
            this.progressError = event.message || '알 수 없는 오류';
            this.progressDone = true;
        }
        await this.service.render();
    }

    public async closeProgressModal() {
        this.showProgressModal = false;
        await this.service.render();
        if (!this.progressError) {
            this.page = 1;
            await this.loadDataset();
        }
    }

    // ── Assign ──

    public async openAssignModal() {
        this.showAssignModal = true;
        this.loadingUsers = true;
        this.selectedUserIds = this.assignedUsers.map((u: any) => u.id);
        await this.service.render();
        const { code, data } = await wiz.call('users');
        if (code === 200) this.userList = data.users || [];
        this.loadingUsers = false;
        await this.service.render();
    }

    public async closeAssignModal() {
        this.showAssignModal = false;
        await this.service.render();
    }

    public isUserSelected(userId: string): boolean {
        return this.selectedUserIds.includes(userId);
    }

    public async toggleUserSelection(userId: string) {
        const idx = this.selectedUserIds.indexOf(userId);
        if (idx >= 0) this.selectedUserIds.splice(idx, 1);
        else this.selectedUserIds.push(userId);
        await this.service.render();
    }

    public async saveAssignment() {
        await wiz.call('assign', { dataset_id: this.id, user_ids: JSON.stringify(this.selectedUserIds) });
        this.showAssignModal = false;
        await this.loadDataset();
    }

    // ── Download ──

    public async toggleDownloadDropdown() {
        this.showDownloadDropdown = !this.showDownloadDropdown;
        this.showModelDropdown = false;
        await this.service.render();
    }

    public async downloadFile(format: string) {
        this.showDownloadDropdown = false;
        await this.service.render();
        try {
            const response = await fetch(
                `/wiz/api/page.dataset.instruction.detail/download?dataset_id=${this.id}&format=${format}`
            );
            if (!response.ok) return;
            const blob = await response.blob();
            const ext = format === 'excel' ? 'xlsx' : 'json';
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${this.dataset?.title || 'dataset'}_instruction.${ext}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch {}
    }

    // ── Upload ──

    public async triggerUpload() {
        if (this.uploading) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx,.xls';
        input.onchange = async (e: any) => {
            const file = e.target.files?.[0];
            if (!file) return;
            this.uploading = true;
            await this.service.render();
            try {
                const formData = new FormData();
                formData.append('file', file);
                const response = await fetch(
                    `/wiz/api/page.dataset.instruction.detail/upload?dataset_id=${this.id}`,
                    { method: 'POST', body: formData }
                );
                const result = await response.json();
                if (result.code === 200) {
                    await this.service.alert.show({
                        title: '업로드 완료',
                        message: `성공: ${result.data?.success || 0}건, 실패: ${result.data?.failed || 0}건`,
                        action: '확인'
                    });
                }
            } catch {}
            this.uploading = false;
            this.page = 1;
            await this.loadDataset();
        };
        input.click();
    }

    // ── System Prompt Toggle ──

    public async toggleSystem(qaId: string) {
        this.expandedSystem[qaId] = !this.expandedSystem[qaId];
        await this.service.render();
    }

    // ── Status Helpers ──

    public statusLabel(s: string): string {
        return { draft: '초안', generating: '생성 중', review: '검수 중', completed: '완료' }[s] || s;
    }
    public statusColor(s: string): string {
        return { draft: 'bg-zinc-100 text-zinc-600', generating: 'bg-amber-50 text-amber-600', review: 'bg-violet-50 text-violet-600', completed: 'bg-emerald-50 text-emerald-600' }[s] || 'bg-zinc-100 text-zinc-600';
    }
    public qaStatusLabel(s: string): string {
        return { pending: '대기', approved: '승인', rejected: '반려', skipped: '건너뜀' }[s] || s;
    }
    public qaStatusColor(s: string): string {
        return { pending: 'bg-zinc-100 text-zinc-500', approved: 'bg-emerald-50 text-emerald-600', rejected: 'bg-red-50 text-red-600', skipped: 'bg-amber-50 text-amber-600' }[s] || 'bg-zinc-100 text-zinc-500';
    }
    public toneLabel(t: string): string {
        const f = this.toneOptions.find(o => o.value === t);
        return f ? f.label : t || '-';
    }
    public taskTypeLabel(v: string): string {
        const f = this.taskTypeOptions.find(o => o.value === v);
        return f ? f.label : v;
    }
    public responseLengthLabel(v: string): string {
        const f = this.responseLengthOptions.find(o => o.value === v);
        return f ? f.label : v || '-';
    }

    public goBack() {
        this.service.href('/dataset/instruction');
    }
}

export default PageDatasetInstructionDetailComponent;